<div class="text-center" style="width: 100%">
    <div>Validating your account...</div>
    <div>
        <mat-spinner></mat-spinner>
    </div>
</div>
